import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { ShareEmailForm } from 'LiveBoard/components/shared/ShareEmailForm'
import { CloseButton } from 'shared/UI/CloseButton'
import startCase from 'lodash/startCase'

import './style.css.scss'

const MODAL_CLASSES = {
  bodyOpenClassName: 'modal-open',
  overlayClassName: 'modal-overlay',
  className: 'mobile-email-share-container'
}

const EmailDialog = (props) => {
  return (
    <Modal isOpen={true} contentLabel='shareDialog' {...MODAL_CLASSES}>
      <CloseButton onClose={props.onClose} />
      <h1 style={{color: props.themeColorHex}}>
        {startCase(props.getTranslation(TRANSLATION_VALUE_KEYS.shareBoard))}
      </h1>
      <ShareEmailForm
        themeColorHex={props.themeColorHex}
        onSubmit={props.onSubmit} />
    </Modal>
  )
}

EmailDialog.propTypes = {
  themeColorHex: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default withTranslation(TRANSLATION_KEYS.mobileEmailDialog)(EmailDialog)